<template>
  <float-label :class="{ error: !valid }">
    <input :type="type"
           :placeholder="label"
           :value="current_value"
           :disabled="disabled"
           v-focus="focus"
           @input="current_value = $event.target.value"
           @focus="touched = true"
           @keypress.enter="$emit('submit', true)">
  </float-label>
</template>

<script>
import FloatLabel from 'vue-float-label/components/FloatLabel';

export default {
  components: {
    'float-label': FloatLabel,
  },

  directives: {
    focus: {
      inserted: (el, binding) => {
        if (binding.value) el.focus();
      },

      componentUpdated: (el, binding) => {
        if (binding.value && !binding.oldValue) el.focus();
      },
    },
  },

  props: {
    validate: { type: [RegExp, Function] },
    type: { type: String, default: 'text' },
    label: { type: String },
    value: { type: String, default: '' },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    focus: { type: Boolean, default: false },
  },

  data() {
    return {
      valid: true,
      touched: false,
      current_value: this.value,
    };
  },

  computed: {
    stripped() {
      return this.current_value.replace(/^\s+|\s+$/g, '');
    },
  },

  watch: {
    stripped() {
      this.doValidate();
      this.$emit('input', this.valid ? this.stripped : '');
    },

    touched() {
      this.doValidate();
    },
  },

  methods: {
    doValidate() {
      const value = this.stripped;
      this.valid = true;

      if (value.length || (this.touched && this.required)) {
        this.valid = !!value.length;

        if (typeof this.validate === 'function') {
          this.valid = this.validate(value);
        } else if (this.validate instanceof RegExp) {
          this.valid = this.validate.test(value);
        }
      }
    },
  },
};
</script>

<style>
/* label can not be matched with scoped styling */

.vfl-has-label > .vfl-label {
  color: #777;
  font-size: 0.8em;
}

.vfl-label.vfl-label-on-focus {
  color: #428bca;
}
.vfl-has-label.error > .vfl-label {
  color: #ff4411;
}
</style>

<style scoped>
.vfl-has-label {
  text-align: left;
  margin: 45px 0 40px;
}

.vfl-label + input {
  display: block;
  width: 100%;
  padding: 2px 2px;
  margin: 0;

  font-size: 1em;

  background: none;
  border: 0;
  border-bottom: 1px solid #aaa;

  /* override firefox outline */
  box-shadow: none;

  transition: border 0.2s;
}

.vfl-label-on-focus + input  {
  border-color: #428bca;
}

.vfl-has-label.error > input {
  border-color: #ff4411;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/FormField.vue